import { useCallback, useEffect, useState } from 'react';
import useApi from '../../../../utils/api';
import { useIsMobile } from '../../../../utils/hooks';
import PaginationMemorial from '../../../../DLS/Pagination';
import { useTranslation } from 'react-i18next';

const SelectGif = ({
  selectedGif,
  setIsLoadingGifs,
  setSelectedGif,
}: {
  selectedGif: number;
  setIsLoadingGifs: Function;
  setSelectedGif: Function;
}) => {
  const [gifs, setGifs] = useState<{ id: number; url: string }[]>([]);
  const [totalGifs, setTotalGifs] = useState<number>(0);
  const { api } = useApi();
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  const getGifs = useCallback(
    (page: number, pageSize: number = 8) => {
      setIsLoadingGifs(true);
      api()
        .get(`/free/gifs?rows=${pageSize}${`&page=${page}`}`)
        .then((response) => {
          if (response.status === 200) {
            const { items, rows } = response.data.data;
            setTotalGifs(rows);
            setGifs(
              items.map(({ id, url }: any) => ({
                id,
                url,
              }))
            );
          }
        })
        .finally(() => setIsLoadingGifs(false));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    getGifs(1);
  }, [getGifs]);

  const getEmptyDiv = () => {
    let emptyDiv = 0;

    if (isMobile) {
      if (gifs.length % 2 !== 0) {
        emptyDiv = 1;
      }
    } else {
      if (gifs.length % 4 !== 0) {
        emptyDiv = 4 - (gifs.length % 4);
      }
    }

    if (emptyDiv) {
      return [...new Array(emptyDiv)].map((_, i) => (
        <div key={`emptyDiv-${i}`} className="w-[170px] md:w-[165px]" />
      ));
    } else {
      return <></>;
    }
  };

  return (
    <div className="flex flex-col">
      <p className="mb-[24px]">{t('leaveDetail.selectGifToSend')}</p>
      <div className="flex flex-wrap justify-between">
        {gifs.map(({ id, url }) => (
          <img
            key={`image-${id}`}
            src={url}
            alt=""
            className={`mb-[16px] max-w-[170px] cursor-pointer rounded-[8px] md:mb-[24px] md:max-w-[165px] ${
              selectedGif === id ? 'outline outline-4 outline-offset-[-4px] outline-primary' : ''
            }`}
            onClick={() => setSelectedGif(id)}
          />
        ))}
        {getEmptyDiv()}
      </div>
      <div className="md:w-[100%]">
        <PaginationMemorial
          defaultPageSize={8}
          onChange={({ page, pageSize }) => {
            getGifs(page, pageSize);
          }}
          totalElements={totalGifs}
          pageSizeOptions={[4, 8, 12]}
        />
      </div>
    </div>
  );
};

export default SelectGif;
